import parameters from './parameteres.json';
import login from './login.json';
import forgotpassword from './forgot-password.json';
import signup from './sign-up.json';

const columnDefs = {
  parameters,
  login,
  forgotpassword,
  signup,
};

export default columnDefs;
